<template>
  <the-header></the-header>
  <!-- <the-search-bar @get-tracking-code="getTrackingCode" /> -->
  <router-view :code="trackingCode" />
</template>

<script>
export default {
  data() {
    return {
      trackingCode: "",
    };
  },
  methods: {
    getTrackingCode(code) {
      this.trackingCode = code;
    },
  },
};
</script>

<style>
.p-card-title {
  background-color: #e7eef1;
  margin: 0 !important;
}

.p-card .p-card-body {
  padding: 0px !important;
}

.p-card .p-card-content {
  padding: 0 !important;
}
</style>
